export default "__VITE_ASSET__BCMASO7E__";